// extracted by mini-css-extract-plugin
module.exports = {"iframe":"IFrame_iframe__4C1_4","experience-editor-holder":"IFrame_experience-editor-holder__EnQ4x"};